angular.module('elfium').constant('USER_REQUIRED_FIELDS', {
	name: 'jméno',
	email: 'email',
	type: 'typ'
});


// WEBPACK FOOTER //
// ./src/app/components/user/userConstants.ts